module.exports = __webpack_public_path__ + "media/whats_your_status_series_your_college_application/step-08-6523e2a6.jpg";